import { useSelector, shallowEqual } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import {selectContextEntity} from "../state/slices/CoreEntity";
import {useCoreEntityContext} from "./useCoreEntitySlice";

const useCurrentFacilityTimezone = () => {
  const defaultFormat = "MM/DD/YYYY hh:mm a";
  const useCoreEntitySlice = useCoreEntityContext();

  const timeZone = useSelector((state) => {
    const tz = useCoreEntitySlice ? selectContextEntity(state).details?.timezone : state.entities.Context?.details?.timezone;
    return tz || moment.tz.guess();
  },shallowEqual);

  /**
   * Converts the given UTC date time to the facility's timezone shifting the time as appropriate.
   */
  const convertUtcDate = (dt) => {
    return moment.utc(dt).tz(timeZone);
  };

  const formatDt = (momentDt, format) => {
    if (format) {
      return momentDt.format(format);
    }
    return momentDt.format(defaultFormat);
  };

  /**
   * Converts the given UTC date time to the facility's timezone shifting the time as appropriate and returning it formatted as specified.
   */
  const convertUtcDateToFormat = (dt, format) => {
    return formatDt(convertUtcDate(dt), format);
  };

  /**
   * Re-creates the given date time in the facility's timezone, then converts to UTC.  Useful in cases where the user's browser's timezone is different than the facility's timezone and you want to ensure a date time is stored/sent in UTC based on the facility's timezone.  For example, if a user enters "1/1/2023 10:00 AM", and their local time is EST but the facility is in PST, this function will treat that input as "1/1/2023 10:00 AM PST" and then convert it to the appropriate UTC time as "2023-01-01T18:00:00-08:00", PST being 8 hours behind UTC.
   */
  const convertToFacilityTimezoneUtc = (dt) => {
    var dateTimeOnly = moment(dt).format("YYYY-MM-DD HH:mm");
    var result = moment.tz(dateTimeOnly, timeZone).utc();
    return result;
  };

  return {
    timeZone: timeZone,
    convertUtcDate: convertUtcDate,
    convertUtcDateToFormat: convertUtcDateToFormat,
    convertToFacilityTimezoneUtc: convertToFacilityTimezoneUtc,
    format: formatDt,
  };
};

useCurrentFacilityTimezone.defaultProps = {
  timeZone: "",
  convertUtcDate: () => {},
  convertUtcDateToFormat: () => {},
  convertToFacilityTimezoneUtc: () => {},
  format: () => {},
};

useCurrentFacilityTimezone.propTypes = {
  timeZone: PropTypes.string,
  convertUtcDate: PropTypes.func,
  convertUtcDateToFormat: PropTypes.func,
  convertToFacilityTimezoneUtc: PropTypes.func,
  format: PropTypes.func,
};

export default useCurrentFacilityTimezone;
